(function(){
  var el = document.querySelector('[data-pf-fit]'); if (!el) return;
  var title = (el.getAttribute('data-title') || '').replace(/\s+/g, ' ');
  function count(s, sub){ return s.split(sub).length - 1; }
  function fits(name){
    var n = name.replace(/-serien$/i, '').trim();
    var series = n !== name.trim();
    var m = n.match(/iPhone\s+(\d{2})\s*(Pro Max|Pro|Plus|Air|Duo)?/i);
    if (!m) {
      if (/^iPhone (Air|Duo)$/i.test(n)) { return new RegExp(n.split(' ')[1], 'i').test(title); }
      return title.toLowerCase().indexOf(n.toLowerCase()) !== -1;
    }
    var num = m[1], variant = (m[2] || '').toLowerCase();
    if (!new RegExp('(^|[^0-9])' + num + '([^0-9]|$)').test(title)) return false;
    if (series) return true;
    var t = title.toLowerCase();
    if (variant === 'pro max') return t.indexOf('pro max') !== -1;
    if (variant === 'pro') return count(t, 'pro') > count(t, 'pro max');
    if (variant) return t.indexOf(variant) !== -1;
    return new RegExp('iphone ' + num + '(?![^a-z]*(pro|plus|air|max))', 'i').test(title);
  }
  function run(){
    var m = null; try { m = JSON.parse(localStorage.getItem('pfModel') || 'null'); } catch(e) {}
    if (!m || !m.name) { el.hidden = true; return; }
    var a = document.createElement('a'); a.href = m.url; a.textContent = 'Visa allt till ' + m.name + ' ›';
    el.textContent = '';
    if (fits(m.name)) {
      el.className = 'pf-fit';
      el.appendChild(document.createTextNode('✓ Passar din '));
      var s = document.createElement('strong'); s.textContent = m.name; el.appendChild(s);
    } else if (/iphone|galaxy|ipad/i.test(title)) {
      el.className = 'pf-fit pf-fit--no';
      el.appendChild(document.createTextNode('Du har valt '));
      var s2 = document.createElement('strong'); s2.textContent = m.name; el.appendChild(s2);
      el.appendChild(document.createTextNode(' – dubbelkolla att produkten passar din modell. '));
      el.appendChild(a);
    } else { el.hidden = true; return; }
    el.hidden = false;
  }
  run(); document.addEventListener('pf:model', run);
})();